'use strict';

var Steps = require('./Steps');
Steps.Step = require('./Step');

module.exports = Steps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.3.0@rc-steps/lib/index.js
 ** module id = 437
 ** module chunks = 0 1
 **/